import { useCallback, useEffect, useState } from 'react';
import { getStellarInfo, IStellarInfo } from '../network';

export const useStellarInfo = (verificationRequestId?: string): [
  IStellarInfo | null,
  boolean,
  Error | null,
  () => void
] => {
  const [result, setResult] = useState<IStellarInfo | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    if (!verificationRequestId) {
      setError(new Error('Verification request ID is not provided'));
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await getStellarInfo(verificationRequestId);
      setResult(response);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error('Unknown error'));
      }
    }

    setIsLoading(false);
  }, [verificationRequestId]);

  useEffect(() => {
    if (verificationRequestId) {
      request();
    }
  }, [request, verificationRequestId]);

  return [result, isLoading, error, request];
};

